var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.059A2.913 2.913 0 004.941 20h7.47a.588.588 0 000-1.177h-7.47C4 18.823 3.176 18 3.176 17.06V2.94c0-.94.824-1.764 1.765-1.764H15.53c.942 0 1.765.824 1.765 1.765v7.47a.588.588 0 001.177 0v-7.47A2.913 2.913 0 0015.529 0H4.941A2.913 2.913 0 002 2.941V17.06z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.765 5.882H6.706c-.353 0-.588-.236-.588-.589s.235-.588.588-.588h7.06c.352 0 .588.235.588.588s-.236.589-.589.589zm.001 4.707h-7.06c-.352 0-.587-.236-.587-.589s.235-.588.588-.588h7.059c.353 0 .588.235.588.588s-.235.589-.588.589zm0 4.706h-7.06c-.352 0-.587-.236-.587-.589 0-.352.235-.588.588-.588h7.059c.353 0 .588.236.588.588 0 .353-.235.589-.588.589z",
    fill: "var(--color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v3m0 0v3m0-3h3m-3 0h-3",
    stroke: "var(--color-secondary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default __webpack_public_path__ + "static/media/add-document.d1f86eb05dd29f80937153740bc6a83e.svg";
export { ForwardRef as ReactComponent };